export default "__VITE_ASSET__Do94j_SQ__"